import React from "react";

import "../Heroes/Heroes.css";

function PageNotFound(props) {
	return (
		<div className="random-container">
			<img
				src="https://i.imgur.com/Ugy1A4Z.jpg"
				alt="page not found"
				className="not-found-img"
			/>
		</div>
	);
}

export default PageNotFound;
